export interface AppVariables {
  WHITELABEL_BRAND: AppVariablesBrand;
  WHITELABEL_HOSTNAME: string;
  WHITELABEL_LOGO: string;
  WHITELABEL_LINK: string;
  WHITELABEL_SMS_CHARS: string;
  WHITELABEL_SMS_NON_ANSI_CHARS: string;
  ACCOUNT_DELETING_DELAY: string;
  FREE_PLAN_LOCATION_LIMIT: number;
  MAX_SAVED_REPLIES: number;
  FULL_CALENDAR_KEY: string;
  UNPAID_PARTY_LIFETIME: number;
  SERVICE_FEE: number;
  APP_VERSION: string;
}

export enum AppVariablesBrand {
  TablesReady = 'TablesReady',
}
